import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { HisLinkComponent } from './component/his-link.component';

/**
 * SharedModule with generic search components (and eventually directives and pipes) to import in child
 * modules of HIS Angular applications. Import HisCoreModule in the root module.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // primeng
        TableModule,
        DataViewModule,
        DialogModule,
        AutoCompleteModule,

        // HIS
        HisCoreSharedModule,
        HisStructureSharedModule
    ],

    declarations: [
        HisLinkComponent
    ],

    exports: [
        HisLinkComponent
    ]
    // NO PROVIDERS! Providers need to go into HisInputCoreModule
} )
export class HisNavigationSharedModule {

}
